
export enum DriverMessageOperationCd {
	ARRIVE = 'Arrive',
	LIST = 'List',
	UPDATE = 'Update'}
